/**
 * What: Browser draft payload preparation, list-summary type and product-lock presentation helper.
 * Transport / data-flow: Pure; no fetch or storage. useStudyAuthoringEditor passes the prepared snapshot to
 *   studyAuthoringClient's current shared authoring operations. StudyBuilderSnapshot is the canonical shared type.
 */
import { studyBuilderWireSnapshotSchema, type StudyBuilderSnapshot } from '@testfeed/shopify-contracts'

export type SavedStudyBuilderDraftSummary = {
  studyId?: string
  deletion?: import('@testfeed/shopify-contracts').StudyAuthoringDeletionReceipt
  state?: import('@testfeed/shopify-contracts').StudyAuthoringState
  productId?: string
  audience?: { value: string; label: string }
  treatmentType?: import('@testfeed/shopify-contracts').ShopifyAuthoredTreatmentType
  versionCount?: number | null
  summary?: import('@testfeed/shopify-contracts').StudyAuthoringSummary

  draftId: string
  title: string
  productTitle: string | null
  productImageUrl?: string | null
  productImageAlt?: string | null
  createdAt?: string
  updatedAt: string
  source: 'opportunity' | 'saved'
}

/**
 * Validates the current form state against the draft contract expected by the Worker.
 */
export function buildStudyBuilderDraftPayload(snapshot: StudyBuilderSnapshot): StudyBuilderSnapshot {
  return studyBuilderWireSnapshotSchema.parse(snapshot)
}

/** True when this snapshot was seeded from a research input and the Shopify product cannot change. */
export function isProductSelectionLocked(snapshot: { productSelectionLocked?: boolean }) {
  return snapshot.productSelectionLocked === true
}
